import type * as React from "react";

import { cn } from "../../cn";

// The "@Name" chip of a mention: agents in the accent pair, people in the info pair (Work OS
// comm-rail colours, as tokens). The editors render it inside BlockNote; apps render stored
// mentions with it, so a mention looks the same written and read.

export type MentionChipProps = Omit<React.ComponentProps<"span">, "children"> & {
  name: string;
  kind?: "person" | "agent" | string;
};

export function MentionChip({ name, kind = "person", className, ...props }: MentionChipProps) {
  return (
    <span
      data-slot="mention-chip"
      data-kind={kind}
      className={cn(
        "rounded-xs px-0.5 font-medium",
        kind === "agent" ? "bg-primary-soft text-primary-text" : "bg-info-soft text-info-text",
        className,
      )}
      {...props}
    >
      @{name}
    </span>
  );
}
